if ($('.type-detail').length) {


    $('.p-detail-inner-header').append($('.p-detail-info').clone());



    $('.p-info-wrapper').append('<div class="customCart"></div>')

    $('.customCart').append($('.p-final-price-wrapper'))
    $('.customCart').append($('.add-to-cart'))



    if ($('.extended-description').length) {
        $('.extended-description').attr('id', 'extended-description');
        $('#p-detail-tabs').append('<li><a href="#extended-description">Parametry</a></li>');
        $('.extended-description').before('<li class="shp-tab ed added"><button >Parametry</button></li>');


        $('li.shp-tab.ed.added button').on('click', function (e) {
            $('li.shp-tab.ed.added').toggleClass("open");
            $('.extended-description').toggleClass("open");
        });



    }

    if ($('.products-related-header').length) {


        $('#content-wrapper').after('<div class="relatedContainer"></div>');
        $('.relatedContainer').append('<div class="container"></div>');
        $('.relatedContainer .container').append($('.products-related-header').clone());
        $('.relatedContainer .container').append($('.products-related').clone());
        $('.relatedContainer .container .products-related-header').attr('id', 'products-related-header');
        $('.relatedContainer .container .products-related').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            infinite: false,

            appendArrows: $('#products-related-header'),

            prevArrow: '<button class="slick-prev">←</button>',
            nextArrow: '<button class="slick-next">→</button>',

            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 3 } },
                { breakpoint: 991, settings: { slidesToShow: 2 } },
                { breakpoint: 767, settings: { slidesToShow: 2 } },
                { breakpoint: 400, settings: { slidesToShow: 1 } },
            ]
        });
        $('#p-detail-tabs').append('<li><a href="#products-related-header">Související produkty</a></li>')

        $('.shp-tabs-wrapper .description-inner').append('<li class="shp-tab rp added"><button >Související produkty</button></li>');
        $('li.shp-tab.rp.added button').on('click', function (e) {
            $('li.shp-tab.rp.added').toggleClass("open");
            $('.relatedContainer').toggleClass("open");

            var $slider = $('.relatedContainer .products-related');

            if (!$slider.hasClass('slick-initialized')) {
                $slider.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true,
                    infinite: false,
                    appendArrows: $('#products-related-header'),
                    prevArrow: '<button class="slick-prev">←</button>',
                    nextArrow: '<button class="slick-next">→</button>',
                    responsive: [
                        { breakpoint: 1199, settings: { slidesToShow: 3 } },
                        { breakpoint: 991, settings: { slidesToShow: 2 } },
                        { breakpoint: 767, settings: { slidesToShow: 2 } },
                        { breakpoint: 400, settings: { slidesToShow: 1 } },
                    ]
                });
            } else {
                $slider.slick('setPosition');
            }
        });






    }

    $(".extended-description h3").text('Parametry');

    if ($('#footer .productUsps').length) {
        $('body.desktop .description-inner').append($('#footer .productUsps').clone());
        $('body.mobile .description-inner .basic-description').append($('#footer .productUsps').clone());
    }
    $('#p-detail-tabs li').each(function () {
        $(this).find('a').text().trim() === 'Popis' ? $(this).find('a').text('Popis produktu') : null;

    })


    $('li[data-testid="tabDescription"] a').on('click', function (e) {
        $('li[data-testid="tabDescription"]').toggleClass("open");
        $('.basic-description').toggleClass("open");

        var $basicDescription = $('.basic-description');
        if ($basicDescription.length && $basicDescription[0].scrollHeight > 800) {

            var $readMoreButton = $('<button type="button" class="readMore">Přečíst více</button>');

            $basicDescription.append($readMoreButton);
            $readMoreButton.on('click', function () {
                $basicDescription.addClass('showMore');
            });
        }
    });



    if ($('.availability-value .availability-label').text().trim() === 'Skladem, do 10 minut') {
        $('.availability-value').addClass('tenMinutes');
        $('.availability-value').append('<span>Jak to funguje?</span>');
        $('.availability-value').append('<img src="/user/documents/upload/sablona/skladem.svg" alt="Jak to funguje?">');
        $('.availability-value span').click(function (e) {

            $.colorbox({
                html: `
                <div class="howItWorksContainer">
                </div>
            `,
                width: "90%",
                maxWidth: "1200px",
                height: "900px"
            });
            getHowItWorksData();
        });
    }

}





function getHowItWorksData() {


    var storredHowItWorks = sessionStorage.getItem(document.location.hostname + '-storredHowItWorksData');

    if (storredHowItWorks) {
        $('.howItWorksContainer').html(storredHowItWorks);
    } else {
        $.ajax({
            url: '/-zajimavosti/doruceni-licence-do-10-minut/',
            type: 'GET',
            success: function (response) {
                var $response = $(response);
                var h1 = $response.find('h1').first().prop('outerHTML');
                var text = $response.find('.text').first().prop('outerHTML');
                var combined = h1 + text;

                $('.howItWorksContainer').html(combined);
                sessionStorage.setItem(document.location.hostname + '-storredHowItWorksData', combined);
            }
        });
    }


}